import React from "react";
import {DispatchOrder} from "../../types/DispatchOrder";
import {DispatchOrderStatusChange} from "../../types/DispatchOrderStatusChange";
import {Constants} from "../common/Constants";

interface CancellationReasonBoxProps {
    dispatchOrder: DispatchOrder;
}

function mostRecentCancellation(dispatchOrder: DispatchOrder): DispatchOrderStatusChange | undefined {
    let cancellationChanges = dispatchOrder.dispatch_order_status_changes.filter(
        statusChange => statusChange.dispatch_order_status.name === Constants.dispatchOrderStatusNames.cancelled
    );
    cancellationChanges.sort((a, b) => b.created_at.localeCompare(a.created_at));
    return cancellationChanges[0];
}

export let CancellationReasonBox = function (props: CancellationReasonBoxProps) {
    if (props.dispatchOrder.dispatch_order_status.name !== Constants.dispatchOrderStatusNames.cancelled) {
        return null;
    }

    let cancellation = mostRecentCancellation(props.dispatchOrder);
    let reasonName = cancellation?.dispatch_order_cancellation_reason?.name || "Weather";
    let note = cancellation?.dispatch_order_cancellation_text;

    return (
        <div className="cancellation-reason-box">
            <div className="cancellation-reason-box-header">
                <div className="cancellation-reason-box-header-text">
                    ACTIVITY CANCELLED DUE TO WORK STOPPAGE
                </div>
            </div>
            <div className="cancellation-reason-box-body">
                <div className="cancellation-reason-box-body-text">
                    <div className="cancellation-reason-box-reason">{`Reason: ${reasonName}.`}</div>
                    {note ? <div className="cancellation-reason-box-note">{note}</div> : null}
                </div>
            </div>
        </div>
    );
};
